import React, { useState, useRef, useEffect } from "react";
import {
  BsFillKeyFill,
  BsFillEyeFill,
  BsFillEyeSlashFill,
  BsPersonFill,
} from "react-icons/bs";
import Logo_Dashboard from "../../../Images/Logo_Dashboard.png";
import Rectangle from "../../../Images/Rectangle_368.png";
import undraw_design_tools_ from "../../../Images/undraw_design_tools_-42-tf 1.png";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  UpdatePassAsync,
  setUpdateOTP,
  setPhoneNumber,
  selectError,
  selectLoggedInUser,
} from "../authSlice";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

const OtpInput = ({ onOtpChange }) => {
  const inputs = useRef([]);
  const [allFieldsFilled, setAllFieldsFilled] = useState(false);

  useEffect(() => {
    inputs.current[0].focus();
  }, []);

  const handleChange = (index, e) => {
    const digit = e.target.value.slice(-1); // Get the last entered digit
    if (/^\d$/.test(digit)) {
      inputs.current[index].value = digit;

      // Move focus to the next empty input field if available
      for (let i = index + 1; i < inputs.current.length; i++) {
        if (inputs.current[i].value === "") {
          inputs.current[i].focus();
          break;
        }
      }
    } else if (digit === "") {
      // If the character is empty (e.g., when Backspace is pressed), move focus to the previous input field
      if (index > 0) {
        inputs.current[index - 1].focus();
      }
    }

    // Check if all input fields are filled in the OTP
    const isOtpFilled = inputs.current.every((input) => input.value !== "");
    setAllFieldsFilled(isOtpFilled);
    onOtpChange(inputs.current.map((input) => input.value).join(""));
  };

  const handleMouseClick = (e) => {
    e.preventDefault();
    const input = e.target;
    input.setSelectionRange(input.value.length, input.value.length);
  };

  const handleKeyDown = (index, e) => {
    if (
      e.key === "Backspace" &&
      index > 0 &&
      inputs.current[index].value === ""
    ) {
      // If Backspace is pressed and the current field is empty, move focus to the previous input field
      inputs.current[index - 1].focus();
    }
  };

  const handleMouseUp = (e) => {
    const input = e.target;
    input.setSelectionRange(input.value.length, input.value.length);
  };

  return (
    <div className="container mx-auto mt-5">
      <div className="flex justify-center">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="mx-1">
            <input
              key={index}
              type="text"
              maxLength={1}
              className="form-control text-center w-10"
              ref={(el) => (inputs.current[index] = el)}
              onChange={(e) => handleChange(index, e)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              onClick={handleMouseClick}
              onMouseUp={handleMouseUp}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showUpdatePasswordForm, setShowUpdatePasswordForm] = useState(false);

  const [showOTPForm, setShowOTPForm] = useState(false);
  const [otp, setOtp] = useState("");
  const [mobile, setMobile] = useState("");
  const [maskedMobile, setMaskedMobile] = useState("");
  const [recievedOtp, setRecievedOtp] = useState("");
  const [timer, setTimer] = useState(10); // Timer value in seconds
  const [otpResent, setOtpResent] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const onChange = () => {};
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Send a POST request to the specified URL using Axios

      const response = await axios.post(
        "http://192.168.1.8:85/api/Auth/OtpSent",
        null,
        {
          params: {
            email: email,
          },
        }
      );

      // Check if the request was successful
      if (response.status === 200) {
        const responseData = response.data;

        setShowOTPForm(true);
        const otpResponse = JSON.parse(responseData.otp);
        console.log(otpResponse);
        const result = JSON.stringify(otpResponse);
        setRecievedOtp(result);
        console.log(result);
      } else {
        // Handle errors if the request was not successful
        console.error("Error:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleVerifyOTP = () => {
    // Compare the OTP received in the response with the OTP you received via SMS
    if (otp === recievedOtp) {
      console.log("OTP verified successfully");

      setShowUpdatePasswordForm(true);
    } else {
      console.log("Entered OTP does not match");
    }
  };

  const handleResendOTP = async () => {
    try {
      // Make a POST request to resend the OTP
      const response = await axios.post(
        "http://192.168.1.8:85/api/Auth/OtpSent",
        null,
        {
          params: {
            email: email,
          },
        }
      );

      // Check if the request was successful
      if (response.status === 200) {
        console.log("OTP resent successfully");
        const responseData = response.data;
        // Reset the timer
        setTimer(10);

        setOtp("");

        setOtpResent(true);
        const otpResponse = JSON.parse(responseData.otp);
        console.log(otpResponse);
        const result = JSON.stringify(otpResponse.result);
        setRecievedOtp(result);
      } else {
        // Handle errors if the request was not successful
        console.error("Error:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
      return;
    }
    try {
      // Send a POST request to the specified URL using Axios
      const response = await axios.post(
        "http://192.168.1.8:85/api/Auth/UpdatePassword",
        {
          email: email,
          password: password,
        }
      );

      // Check if the request was successful
      if (response.status === 200) {
        console.log(response.data);
        toast.success("Password Updated successfully");
        navigate("/");
      } else {
        // Handle errors if the request was not successful
        console.error("Error:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  return (
    <>
      <div className="w-full h-screen flex">
        <div
          className="hidden md:flex md:w-1/2 h-full bg-cover bg-center relative"
          style={{ backgroundImage: `url(${Rectangle})` }}
        >
          <div className="absolute top-0 left-6 right-0 w-full h-full flex flex-col justify-between">
            <nav className="flex items-center bg-transparent p-4">
              <a href="#" className="flex items-center text-dark">
                <img src={Logo_Dashboard} alt="logo" className="h-16 mr-2" />
                <div>
                  <h6 className="m-0">Stamp & Registration Department</h6>
                  <p className="m-0 text-xs">Government of Uttarakhand</p>
                </div>
              </a>
            </nav>
            <div className="flex-grow flex flex-col items-center justify-center">
              <img
                src={undraw_design_tools_}
                alt="Overlay Image"
                className="w-80 z-10"
              />
              <div className="mt-5 ml-4 pl-5 flex justify-center items-center">
                <div className="md:w-2/3 px-4">
                  <h6>Public Data Entry allows citizen for:</h6>
                  <ol className="list-decimal ml-5">
                    <li>Registering Online username and password</li>
                    <li>Document entry for registration.</li>
                    <li>Upload documents and online payments</li>
                    <li>
                      Online appointments to visit sub-registrar office for
                      document registration
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center w-full md:w-1/2">
          <div className="bg-slate-200 rounded-2xl p-8 shadow-lg w-11/12 max-w-sm mx-4 md:mx-auto">
            <h6 className="text-left text-xl font-bold mb-6">Reset Password</h6>
            {!showOTPForm && !showUpdatePasswordForm && (
              <>
                <h6 className="text-center">Forget Password</h6>
                <form noValidate className="space-y-6" onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label htmlFor="email" className="block text-gray-700">
                      Enter Email
                    </label>
                    <div className="flex items-center border border-gray-300 rounded mt-2">
                      <span className="px-3 text-gray-600">
                        <BsPersonFill />
                      </span>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        className="flex-1 py-2 px-4 focus:outline-none"
                        required
                      />
                      {/* {errors.email && (
                          <p className="text-red-500">{errors.email.message}</p>
                        )} */}
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="w-full py-2 mt-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    Get OTP
                  </button>
                  <div className="flex justify-center mt-2">
                    <p>
                      <a href="/Login" className="text-blue-500">
                        Login
                      </a>
                    </p>
                  </div>
                </form>
              </>
            )}

            {showOTPForm && !showUpdatePasswordForm && (
              <>
                <h5 className="mb-3 text-center">Enter OTP</h5>
                <p className="text-center">OTP sent to {email}</p>
                <OtpInput onOtpChange={setOtp} />
                <button
                  className="w-full mt-3 py-2 bg-blue-500 text-white rounded-lg"
                  onClick={handleVerifyOTP}
                  disabled={otp.length !== 4}
                >
                  Verify
                </button>
                <div className="text-center mt-3">
                  {otpResent ? (
                    <p>{`timer < 10 ? 00:0${timer} : 00:${timer}`}</p>
                  ) : (
                    <button className="text-blue-500" onClick={handleResendOTP}>
                      Resend OTP
                    </button>
                  )}
                </div>
              </>
            )}

            {showUpdatePasswordForm && (
              <>
                <h5 className="mb-3 text-center">Update Password</h5>
                <form onSubmit={handleUpdatePassword}>
                  <div className="mb-3">
                    <label className="block mb-2">New Password</label>
                    <div className="relative">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <BsPersonFill />
                      </span>
                      <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="block mb-2">Confirm Password</label>
                    <div className="relative">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <BsPersonFill />
                      </span>
                      <input
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg"
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 mb-2 py-2 bg-blue-500 text-white rounded-lg"
                  >
                    Submit
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
